import { render, staticRenderFns } from "./viewList.vue?vue&type=template&id=5ba64f84&"
import script from "./viewList.vue?vue&type=script&lang=js&"
export * from "./viewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports